<app-page-wrapper>
  <app-loading-spinner *ngIf="!allListItems;else main_content"></app-loading-spinner>

  <ng-template #main_content>
    <h1 class="d-flex">
      Accounts
    </h1>
    <div class="d-flex justify-content-between mb-3">
      <div class="text-nowrap my-auto">
        <input class="form-control search-input d-inline" (input)="searchValue = searchBox.value;queueSearchTerm(searchBox.value)"
          placeholder="Search" #searchBox id="search-box">
      </div>
    </div>

    <app-loading-spinner *ngIf="searching"></app-loading-spinner>

    <div class="mt-4" *ngIf="searchValue && noMatches">No accounts found.</div>

    <table class="table" [class.d-none]="searching"> <!-- using ngIf (instead of d-none) here breaks searching -->
      <thead>
        <th>
          <app-sort-toggle columnName="Name" (orderChange)="getAccounts($event)">Name</app-sort-toggle>
        </th>
        <th>Email</th>
        <th>
          <app-sort-toggle columnName="ID" (orderChange)="getAccounts($event)">ID</app-sort-toggle>
        </th>
        <th>Password</th>
        <th>Expires</th>
        <th></th>
        <th></th>
      </thead>
      <tbody>
        <tr *ngFor="let obj of listItems$ | async" [class.hover]="editObj !== obj && deleteObj !== obj" (click)="navTo(obj)">
          <td>
            <div class="d-flex align-items-center">
              <a *ngIf="getRouterLink(obj) !== ''" [routerLink]="getRouterLink(obj)">
                <app-profile-picture class="mr-2" [name]="obj.Name"></app-profile-picture>
                <span *ngIf="editObj !== obj">{{ obj.Name }}</span>
              </a>
              <span *ngIf="getRouterLink(obj) === ''">
                <app-profile-picture class="mr-2" [name]="obj.Name"></app-profile-picture>
                <span *ngIf="editObj !== obj">{{ obj.Name }}</span>
              </span>
              <input class="form-control ml-2" *ngIf="editObj === obj" [(ngModel)]="editObj.Name" disabled="{{ saving }}">
            </div>
          </td>
          <td>
            <span *ngIf="editObj !== obj">{{ obj.Email }}</span>
            <input class="form-control" *ngIf="editObj === obj" [(ngModel)]="editObj.Email" disabled="{{ saving }}">
          </td>
          <td>
            <span *ngIf="editObj !== obj">{{ obj.ExternalID }}</span>
            <input class="form-control" *ngIf="editObj === obj" [(ngModel)]="editObj.ExternalID" disabled="{{ saving }}">
          </td>
          <td>
            <span *ngIf="editObj !== obj">*****</span>
            <input class="form-control" *ngIf="editObj === obj" [(ngModel)]="editObj.Password" disabled="{{ saving }}">
          </td>
          <td>
            <span *ngIf="editObj !== obj">{{ obj.ExpirationDate | date }}</span>
            <app-datepicker *ngIf="editObj === obj" [(model)]="editObj.ExpirationDate" [disabled]="saving"></app-datepicker>
          </td>
          <td class="icon">
            <span (click)="startEditObj($event, obj)" *ngIf="!editObj && !deleteObj" ngbTooltip="Edit">
              <i class="fal fa-pencil-alt pointer"></i>
            </span>
            <span (click)="updateAccount($event)" *ngIf="!saving && editObj === obj" ngbTooltip="Save">
              <i class="fal fa-save pointer"></i>
            </span>
          </td>
          <td class="icon">
            <span (click)="deleteAccount(obj)" *ngIf="!editObj && !deleteObj" ngbTooltip="Delete">
              <i class="fal fa-trash-alt pointer"></i>
            </span>
            <span (click)="cancelEditObj($event, obj)" *ngIf="!saving && editObj === obj" ngbTooltip="Cancel">
              <i class="fal fa-times pointer"></i>
            </span>
            <span *ngIf="deleteObj === obj || (saving && editObj === obj)">
              <i class="fal fa-spinner fa-spin"></i>
            </span>
          </td>
        </tr>
      </tbody>
    </table>
  </ng-template>
</app-page-wrapper>
